<template>
  <div class="centerx sidebar">
    <vs-sidebar
      :click-not-close="true"
      position-right
      parent="body"
      default-index="0"
      :class="this.className"
      v-model="active"
    >
      <div v-html="this.content" id="side_bar_cont" class="content"></div>
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      content: "",
      className: "",
    };
  },
  methods: {
    renderDom() {
      window.setTimeout(() => {
        var divP = document.getElementById("side_bar_cont");
        divP.innerHTML = "";
        var div = document.createElement("div");
        div.id = "vuejs-render";
        divP.appendChild(div);
        var tmp = Vue.extend({
          template: this.content,
        });
        new tmp().$mount(div);
        this.attachCloseButton();
        $(".js-example-basic").select2();

        app.__vue__.disabledWithoutPermission();
      }, 100);
    },

    attachCloseButton() {
      const element = document.getElementById("side_bar_cont");
      let button = document.createElement("BUTTON");
      button.setAttribute("type", "button");
      button.setAttribute("class", "btn bg-transparent");
      button.setAttribute(
        "onclick",
        "app.__vue__.$refs.vue_sidebar.closeSidebar()",
      );
      button.innerHTML = "<i class='fas fa-times'></i>";
      let buttonContainer = document.createElement("div");
      buttonContainer.setAttribute("class", "close-sidebar-container");
      buttonContainer.appendChild(button);
      element.insertBefore(buttonContainer, element.firstChild);
    },
    closeSidebar() {
      if (app.__vue__.$refs) {
        for (let ref in app.__vue__.$refs) {
          if (ref.includes("vuetable")) {
            var params = {
              ref: ref,
              page: 1,
              itemId: null,
            };
            params = app.__vue__.$refs[ref].prepareDataVueTableOptions(params);
            app.__vue__.setVueTableOptions(params);
            break;
          }
        }
      }
      app.__vue__.$refs.vue_sidebar.active = false;
      var url = window.location.href.replace(/#.*$/, "");
      history.replaceState(null, null, url);

    },
    toggle(urlBody, className = "") {
      let dataSidebar = this;
      this.className += " " + className;
      app.__vue__.appendLoader();
      axios.get(urlBody).then(function (response) {
        let tempElement = document.createElement('div');
        tempElement.innerHTML = response.data;
        dataSidebar.content = tempElement.innerHTML;
        dataSidebar.renderDom();
        window.setTimeout(() => {
          dataSidebar.active = true;
          $(".tabs-component li a").click(function (e) {
            e.preventDefault();
          });
        }, 100);
        app.__vue__.removeLoader();
      });
    },
  },
};
</script>

<style scoped>
:deep(.vs-sidebar.vs-sidebar-primary.vs-sidebar-position-right) {
  max-width: 440px;
  padding: 10px;
}
</style>
